import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ title, description, keywords, url, itempropDescription }) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name='title' content={title} />
      <meta name='description' content={description} />
      {keywords && <meta name='keywords' content={keywords} />}

      {/* Itemprop (Google / Schema.org) */}
      <meta itemprop='name' content={title} />
      <meta itemprop='description' content={itempropDescription || description} />

      {/* Open Graph / Facebook */}
      <meta property='og:type' content='website' />
      {url && <meta property='og:url' content={url} />}
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />

      {/* Twitter */}
      <meta property='twitter:card' content='summary_large_image' />
      {url && <meta property='twitter:url' content={url} />}
      <meta property='twitter:title' content={title} />
      <meta property='twitter:description' content={description} />
    </Helmet>
  );
};

export default SEO;
